import { IBaseModel } from "../BaseModel";
import { SelectOption } from "../../types/system/SelectOption";

// Matches TemplateType on the API, and Core's TemplateType - the template sync writes the number
// straight into each customer's database.
export enum TemplateType {
  All = 0,
  Message = 1,
  Email = 2,
  Product = 3,
  ConditionDescription = 4,
}

export const templateTypeLabels: Record<TemplateType, string> = {
  [TemplateType.All]: "All",
  [TemplateType.Message]: "Message",
  [TemplateType.Email]: "Email",
  [TemplateType.Product]: "Product description",
  [TemplateType.ConditionDescription]: "Condition description",
};

// All is the "every type" filter value on the API, not a type a template can have.
export const templateTypeOptions: SelectOption[] = Object.values(TemplateType)
  .filter((value): value is TemplateType => typeof value === "number" && value !== TemplateType.All)
  .map((value) => ({ value, label: templateTypeLabels[value] }));

export interface ITemplate extends IBaseModel {
  type: TemplateType;
  title: string;
  body: string;
}

export interface IUpsertTemplateRequest {
  type: TemplateType;
  title: string;
  body: string;
}
